import { Result } from "antd";

const SignupComplete = () => {
  return (
    <Result
      status="success"
      title="Successfully Registered"
      subTitle="Your hospital is successfully registered with us. Please sign in to for more details."
    />
  );
};

export default SignupComplete;
